<myqq-default-layout *ngIf="authenticated | async" pageTitle="Home">
  <div class="fld-col flg-5 pwy-5 pwx-6">
    <div
      class="ds-fl jc-end"
      *ngrxLet="accountAndMembershipStatus$ | async as accountStatus"
    >
      <button
        *ngIf="!!accountStatus && !accountStatus.hasMembership"
        myqq-button
        id="find-membership"
        class="raised"
        color="tertiary"
        (click)="handleRelink(accountStatus)"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="handleRelink(accountStatus)"
        aria-label="Find membership"
      >
        Find Membership
      </button>
    </div>
    <div
      *ngrxLet="name$ as name"
      class="as-ctr as-dsk-str cards"
      data-cy="welcome"
    >
      <span *ngIf="!!name; else genericWelcome">
        <h1 class="ds-dsk-only private">Welcome {{ name }}</h1>
        <div class="ds-mbl-only private">
          <mat-card class="ct-primary card">
            <mat-card-content>
              <mat-card-title class="ct-primary">
                Welcome
              </mat-card-title>
              {{ name }}
            </mat-card-content>
          </mat-card>
        </div>
      </span>
      <ng-template #genericWelcome>
        <h1>Welcome!</h1>
        <mat-card class="ds-mbl-only ct-primary card ai-ctr">
          <mat-card-title>
            Welcome
          </mat-card-title>
        </mat-card>
      </ng-template>
    </div>

    <div
      *ngrxLet="{softCancel: softCancel$ | async, failedInvoice: failedInvoice$ | async, marketingContents: marketingContents$ | async, b2bBenefit: b2bBenefit$ | async, nextStep: nextStep$ | async, stayAndSave: stayAndSaveSubscriptionDiscount$ | async} as context"
    >
      <div
        *ngIf="!!context.marketingContents && !!context.nextStep; else loading"
        class="fld-col fld-dsk-row flg-5 cards"
      >
        <ng-container *ngIf="!!context.softCancel">
          <a (href)="$event.preventDefault()">
            <mat-card
              @rollDownUp
              class="card mwr-5"
              id="soft-cancel-card"
              tabindex="0"
              (click)="emailSupport()"
              (keyup.enter)="emailSupport()"
            >
              <mat-card-content>
                <mat-icon>info</mat-icon>
                <h2 class="ta-c mwt-0">{{ context.softCancel.title }}</h2>
                <p class="pwa-5 fs-d1">{{ context.softCancel.description }}</p>
              </mat-card-content>
            </mat-card>
          </a>
        </ng-container>
        <ng-container *ngIf="!!context.failedInvoice">
          <a (href)="$event.preventDefault()">
            <mat-card
              @rollDownUp
              class="card mwr-5"
              data-cy="failed-payment-card"
              id="failed-payment-card"
              tabindex="0"
              (click)="handleFailedPayment(context.failedInvoice.route)"
              (keyup.enter)="handleFailedPayment(context.failedInvoice.route)"
            >
              <mat-card-content>
                <mat-icon>warning_outline</mat-icon>
                <h2 class="ta-c mwt-0">{{ context.failedInvoice.title }}</h2>
                <p class="pwa-5 fs-d1">
                  {{ context.failedInvoice.description }}
                </p>
              </mat-card-content>
            </mat-card>
          </a>
        </ng-container>
        <div
          class="stay-and-save-container"
          *ngIf="!context.softCancel && !!context.stayAndSave"
        >
          <myqq-stay-and-save-progress
            class="stay-and-save-card"
            [stayAndSaveDetail]="context.stayAndSave"
          ></myqq-stay-and-save-progress>
        </div>
        <ng-container
          *ngFor="let marketingContent of context.marketingContents"
        >
          <myqq-marketing-content
            data-cy="marketing-step"
            [marketingContent]="marketingContent"
            (clickCard)="handleClickMarketingCard(marketingContent)"
          >
          </myqq-marketing-content>
        </ng-container>
        <ng-container *ngIf="context.b2bBenefit && enableB2bFlag$ | async">
          <myqq-b2c-card
            [companyName]="context.b2bBenefit.companyName"
            [contractDescription]="context.b2bBenefit.contractDescription"
          ></myqq-b2c-card>
        </ng-container>
        <ng-container *ngIf="!!context.nextStep">
          <a (href)="$event.preventDefault()">
            <mat-card
              @rollDownUp
              class="card mwr-5"
              tabindex="0"
              (click)="handleNextStep(context.nextStep.route)"
              (keyup.enter)="handleNextStep(context.nextStep.route)"
              data-cy="next-step"
            >
              <mat-card-content>
                <div class="fld-col fld-dsk-rowr">
                  <span class="fls-1-1"></span>
                  <img
                    src="{{ cdnHost }}/img/shopping-quackals.svg"
                    alt="Quackals with shopping bag"
                  />
                  <mat-card-title class="ta-c">
                    {{ context.nextStep.title }}
                  </mat-card-title>
                </div>
              </mat-card-content>
            </mat-card>
          </a>
        </ng-container>
        <a (href)="$event.preventDefault()">
          <mat-card
            class="card mwr-5"
            tabindex="0"
            routerLink="/info"
            (keyup.enter)="handleWhyQQ()"
          >
            <mat-card-content>
              <div class="fld-col fld-dsk-rowr">
                <span class="fls-1-1"></span>
                <img
                  src="{{ cdnHost }}/img/Why_myQQ.svg"
                  alt="Quackals with
                    trophy"
                />
                <mat-card-title class="ta-c">
                  Why myQQ?
                </mat-card-title>
              </div>
            </mat-card-content>
            <mat-card-actions (click)="handleWhyQQ()"> </mat-card-actions>
          </mat-card>
        </a>
      </div>
    </div>
  </div>
</myqq-default-layout>
<ng-container *ngIf="!(authenticated | async)">
  <myqq-landing class="vw-p100 vh-p100"></myqq-landing>
</ng-container>
<ng-template #loading>
  <myqq-loading>
    <h3>Getting data ...</h3>
  </myqq-loading>
</ng-template>
